export default {"src":"/_next/static/media/SandboxBadge.dac96828.svg","height":22,"width":78,"blurWidth":0,"blurHeight":0};